import type React from "react";
import { Barrel, BeerBox, BookmarkFill, Projector } from "./svgs";

const internalIcons = {
  barrel: Barrel,
  "beer-box": BeerBox,
  "bookmark-fill": BookmarkFill,
  projector: Projector,
} as const;

export const iconNames = Object.keys(internalIcons) as Array<
  keyof typeof internalIcons
>;

export type IconName = keyof typeof internalIcons;

export interface IconsProps {
  name: IconName;
  width?: number | string;
  height?: number | string;
}

export const Icons: React.FC<IconsProps> = ({ name, width, height }) => {
  const IconComponent = internalIcons[name];

  if (!IconComponent) {
    console.warn(`[InternalIcon] Icon "${name}" not found`);
    return null;
  }

  return <IconComponent width={width} height={height} />;
};
